<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="showlist" ref="showlist">
      <div class="row showheader">
        <div class="col-md-12">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="searchHint" v-model="searchStr" />
            <div class="input-group-btn">
              <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right">
                <template #trigger>
                  {{ chooseTitle }} &nbsp;<span class="caret"></span>
                </template>
                <li v-for="ts in possibleDates"><a href="javascript:;" v-on:click="selectDate(ts)">{{ groupTitle(ts) }}</a></li>
              </Dropdown>
            </div>
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" v-on:click="clearSearch"><i class="fa fa-fw fa-times"></i></button>
            </span>
          </div>
        </div>
      </div>
      <template v-for="(shows, ts) in groupedShowsFiltered">
        <div class="row showgrouptitle">
          <div class="col-md-12">
            <h4 class="daytitle">{{ groupTitle(ts) }}</h4>
          </div>
        </div>
        <div class="row showgroup">
          <show-item v-for="show in shows" :baseDomain="baseDomain" :settings="settings" :key="show.id" :show="show" v-on:showClicked="buyTicketClicked"></show-item>
        </div>
      </template>
      <seat-map ref="seatMap" :column="column" :showButtons="true" :ticketShopId="shopId" :show="activeShow" :seatMap="seatMap" v-if="seatMap && showSeatMap" v-on:confirmSelection="seatSelectionConfirmed" v-on:closeModal="closeSeatMap" v-on:seatSelected="seatSelected" v-on:seatDeselected="seatDeselected"></seat-map>
    </div>
  </div>
</template>
<style>
.showgroup {
  border-bottom: 1px #ECEFF1 solid;
}
.daytitle {
  color: #78909C;
}
</style>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { DateTime } from 'luxon'
import seatmap from '~/lib/seatmap'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

export default {
  data () {
    return {
      resourcepoolId: null,
      shows: [],
      groupedShows: {},
      showSeatMap: false,
      seatMap: null,
      selectedSeats: [],
      seatTicketId: null,
      activeShow: false,
      searchStr: '',
      selectedDate: null,
      showInterval: null
    }
  },
  mixins: [components, seatmap],
  computed: {
    searchHint () {
      return this._('Search by name')
    },
    data () {
      return (this.component.data !== '' ? JSON.parse(this.component.data) : false)
    },
    settings() {
      return this.shopSettings(this.shopId)
    },
    productCount () {
      return 1
    },
    resourceCount () {
      return 1
    },
    reservationCount () {
      return this.selectedSeats.length
    },
    chooseTitle () {
      if (this.selectedDate) {
        return this.groupTitle(this.selectedDate)
      }
      return this._('Choose a date')
    },
    possibleDates () {
      let dates = []
      for (var ts in this.groupedShows) {
        if (Object.prototype.hasOwnProperty.call(this.groupedShows, ts)) {
          dates.push(ts)
        }
      }
      return dates
    },
    groupedShowsFiltered () {
      if (!this.searchStr && !this.selectedDate) {
        return this.groupedShows
      }
      let filtered = {}
      for (var ts in this.groupedShows) {
        if (Object.prototype.hasOwnProperty.call(this.groupedShows, ts)) {
          filtered[ts] = []
          for (var i = 0; i < this.groupedShows[ts].length; i++) {
            let show = this.groupedShows[ts][i]
            if (!this.searchStr ||
                show.text.match(new RegExp(this.searchStr, 'i')) ||
                show.agelimit === this.searchStr.toUpperCase() || 
                (show.attributes && show.attributes[this.searchStr.toLowerCase()])) {
              if (!this.selectedDate || this.selectedDate === ts) {
                filtered[ts].push(show)
              }
            }
          }
          if (!filtered[ts].length) {
            delete filtered[ts]
          }
        }
      }
      return filtered
    }
  },
  methods: {
    matchHeight: debounce(
      function () {
        if (process.browser) {
          if (!this.$refs || !this.$refs.showlist) {
            return null
          }
          let topShow = this.getTopShow()
          const topShowId = topShow ? topShow.id : null
          const topShowPos = topShow ? topShow.offsetTop : 0
          const scrollPos = this.$refs.showlist.scrollTop
          this.$nextTick(function () {
            // jQuery('.match-row').matchHeight()
            let offset = 0
            if (topShowId) {
              let topShow = document.getElementById(topShowId)
              if (topShow) {
                offset = topShow.offsetTop - topShowPos
              }
            }
            this.$refs.showlist.scrollTop = scrollPos + offset
          })
        }
      }, 100
    ),
    getTopShow () {
      if (!this.$refs || !this.$refs.showlist) {
        return null
      }
      const scrollPos = this.$refs.showlist.scrollTop
      const shows = document.getElementsByClassName('showitem')
      for (let i = 0; i < shows.length; i++) {
        let show = shows[i]
        if (show.offsetTop > scrollPos) {
          return show
        }
      }
      return null
    },
    selectDate (ts) {
      this.selectedDate = ts
      this.groupShowsByDate(this.shows)
    },
    clearSearch () {
      this.searchStr = ''
      this.selectedDate = null
      this.groupShowsByDate(this.shows)
    },
    loadShows () {
      let d = new Date()
      let yy = d.getFullYear()
      let mm = d.getMonth() + 1
      let dd = d.getDate()
      if (mm < 10) {
        mm = '0' + mm
      }
      if (dd < 10) {
        dd = '0' + dd
      }
      let resourcepoolStr = ''
      if (this.data && this.data.resourcepoolId !== null) {
        this.resourcepoolId = this.data.resourcepoolId
        resourcepoolStr += '&resourcepool=' + this.data.resourcepoolId
      } 
      let fromStr = yy + '-' + mm + '-' + dd
      // let fromStr = 'now'
      axios.get(this.baseDomain + this.shopId + '/showschedule.json?from=' + fromStr + '&pos=true&version=' + this.version + '&apikey=' + this.apiKey + resourcepoolStr)
      .then(response => {
        this.shows = response.data.data
        this.groupShowsByDate(response.data.data)
        this.matchHeight()
      })
      .catch(function () {
        console.log('Failed to load transactions.')
      })
    },
    throttledReload: throttle(function () { this.loadShows() }, 1000, { leading: false, trailing: true }),
    groupShowsByDate (shows) {
      this.groupedShows = {}
      for (var i = 0; i < shows.length; i++) {
        let offset = DateTime.now().toUnixInteger() - DateTime.fromFormat(shows[i].start_date, 'yyyy-MM-dd HH:mm').toUnixInteger()
        if (offset > 15 * 60 && !this.selectedDate) { // Shows that have started more than 15 minutes ago should not be shown, unless selectedDate is set
          continue
        }
        let currTs = DateTime.fromFormat(shows[i].start_date, 'yyyy-MM-dd HH:mm').startOf('day').toUnixInteger()
        if (!this.groupedShows[currTs]) {
          this.groupedShows[currTs] = []
        }
        this.groupedShows[currTs].push(shows[i])
      }
    },
    groupTitle (ts) {
      return this._(DateTime.fromSeconds(Number(ts)).toFormat('cccc')) + ' ' + DateTime.fromSeconds(Number(ts)).toFormat(this.dateFormat)
    },
    // Sorry but these are pretty much copy pasted from ReservableProductListItem.vue @todo refactor into some separate thingy perhaps
    buyTicketClicked (show) {
      if(parseInt(show.upcoming, 10) === 1) return;
      let numSeats = null
      if (arguments.length > 1) {
        numSeats = parseInt(arguments[1])
      }
      axios.get(`${this.baseDomain}${this.shopId}/${this.locale}/shows/${show.id}.json?details=true&pos=true`)
      .then(response => {
        show = response.data
        // if we don't have seat selection, add it to basket directly
        if (!parseInt(show.showseatmap)) {
          this.addShowToBasket(show, numSeats)
        } else {
          // otherwise open seatmap
          this.seatMap = null
          this.openSeatMap(show, false, this.shopId)
        }
      })
    },
    addShowToBasket (show, numSeats) {
      let $this = this
      show.product.currency = this.shopSettings(this.shopId).currency
      let data = {
        version: this.version,
        locale: this.locale,
        product: show.product,
        showId: show.id,
        shopId: this.shopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: numSeats ? numSeats : this.reservationCount,
        reservationDateStart: show.startdate,
        reservationTimeStart: show.starttime,
        reservationTimeEnd: show.endtime
      }
      if (show.enddate && show.startdate !== show.enddate) {
        data.reservationDateEnd = show.enddate
      }
      if (this.selectedSeats.length) {
        data.selectedSeats = this.selectedSeats.join(',')
        if (this.seatTicketId) {
          data.seatTicket = this.seatTicketId
        }
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.marketingname(show.product))
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
    },
    getDMY (d) {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear()
    },
    getYMD (d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
    },
    getHM (d) {
      return d.getHours() + '.' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
    },
    hideStartedMovies () {
      this.showInterval = setInterval(() => {
        if (this.shows && this.shows.length) {
          this.groupShowsByDate(this.shows)
        }
      }, 60000)
    }
  },
  updated () {
    if (this.data && this.resourcepoolId !== this.data.resourcepoolId) {
      this.loadShows()
    }
    this.matchHeight()
  },
  watch: {
    version () {
      this.loadShows()
    }
  },
  mounted () {
    this.loadShows()
    if(!this.events) {
      let events = {}
      events['showUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReload()
        }
      }
      events['productUpdate'] = (message) => {
        for (var i = 0; i < this.shows.length; i++) {
          let show = this.shows[i]
          if (this.shopId == message.shopId && show.product_id == message.data.id) {
            return this.throttledReload()
          }
        }
      }
      events['resourceUpdate'] = (message) => {
        for (var i = 0; i < this.shows.length; i++) {
          let show = this.shows[i]
          if (this.shopId == message.shopId && show.resource_id == message.data.id) {
            return this.throttledReload()
          }
        }
      }
      events['availabilityUpdate'] = (message) => {
        let $this = this
        if (message.shopId != this.$store.state.shopId) {
          return
        }
        this.throttledReload()
        if (!this.activeShow) {
          return
        }
        if (message.data && message.data.affectedProducts && message.data.affectedProducts.findIndex(item => String(item) === String(this.activeShow.product_id)) !== -1) {
          this.openSeatMap(this.activeShow, function () {
            $this.$refs.seatMap.redraw($this.seatMap)
          }, this.shopId)
        }
      }
      this.events = events
    }
    this.enableEventBus()
    this.matchHeight()
  },
  created () {
    this.hideStartedMovies()
  },
  beforeUnmount () {
    clearInterval(this.showInterval)
  }
}

</script>

<style scoped>
.showheader {
  margin-top: 15px;
  position: relative;
  z-index: 11;
}
</style>